const TURKISH_MAP: Record<string, string> = {
  ç: "c",
  ğ: "g",
  ı: "i",
  i̇: "i",
  ö: "o",
  ş: "s",
  ü: "u",
};

/** URL slug with Turkish characters transliterated: "Merve Çağlar" → "merve-caglar". */
export function slugify(value: string): string {
  return value
    .toLocaleLowerCase("tr")
    .replace(/[çğıöşü]|i̇/g, (char) => TURKISH_MAP[char] ?? char)
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
